var render, staticRenderFns
import script from "./CharBar.vue?vue&type=script&lang=js"
export * from "./CharBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ece1593')) {
      api.createRecord('1ece1593', component.options)
    } else {
      api.reload('1ece1593', component.options)
    }
    
  }
}
component.options.__file = "src/components/charts/CharBar.vue"
export default component.exports